import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Form } from "react-bootstrap";
import { Input } from "@frui.ts/bootstrap";
import RefundRequestViewModel from "../../../viewModels/notice/refundRequest/refundRequestViewModel";
import { RadioArray } from "../../../controls/radioArray";
import ReactMarkdown from "react-markdown";
import AlertWithInfoIcon from "../../common/alertWithInfoIcon/alertWithInfoIcon";
import CustomerRefundApplicationOrderSourceType from "../../../entities/customerRefundApplicationOrderSourceType";

const OrderSourceTypeView: FunctionComponent<{
  vm: RefundRequestViewModel;
}> = observer(({ vm }) => {
  const t = vm.translateAttribute;
  const bankAccountInputId = "request-refund-bank-account";

  return (
    <fieldset>
      <>
        <Form.Group className="mb-3">
          <RadioArray
            custom
            label={
              <ReactMarkdown className="markdown">
                {t(`chargeOrderSourceType.${CustomerRefundApplicationOrderSourceType.Eshop}`)}
              </ReactMarkdown>
            }
            target={vm.notice}
            property="chargeOrderSourceType"
            isNumeric={false}
            id={CustomerRefundApplicationOrderSourceType.Eshop}
            option={CustomerRefundApplicationOrderSourceType.Eshop}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <RadioArray
            custom
            label={
              <ReactMarkdown className="markdown">
                {t(`chargeOrderSourceType.${CustomerRefundApplicationOrderSourceType.Kiosk}`)}
              </ReactMarkdown>
            }
            target={vm.notice}
            property="chargeOrderSourceType"
            isNumeric={false}
            id={CustomerRefundApplicationOrderSourceType.Kiosk}
            option={CustomerRefundApplicationOrderSourceType.Kiosk}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <RadioArray
            custom
            label={
              <ReactMarkdown className="markdown">
                {t(`chargeOrderSourceType.${CustomerRefundApplicationOrderSourceType.Salespoint}`)}
              </ReactMarkdown>
            }
            target={vm.notice}
            property="chargeOrderSourceType"
            isNumeric={false}
            id={CustomerRefundApplicationOrderSourceType.Salespoint}
            option={CustomerRefundApplicationOrderSourceType.Salespoint}
          />
        </Form.Group>
      </>
      {vm.notice.chargeOrderSourceType !== CustomerRefundApplicationOrderSourceType.Unknown && (
        <div className="mt-4 mb-7 text-muted">
          <AlertWithInfoIcon variant="info" className="font-weight-bold">
            {t(`chargeOrderSourceTypeNotice.${vm.notice.chargeOrderSourceType}`)}
          </AlertWithInfoIcon>
        </div>
      )}
      {vm.notice.chargeOrderSourceType === CustomerRefundApplicationOrderSourceType.Salespoint && (
        <Form.Group className="mb-3">
          <Form.Label id={bankAccountInputId}>{t("bankAccount")}</Form.Label>
          <Input target={vm.notice} property="bankAccount" aria-labelledby={bankAccountInputId} />
        </Form.Group>
      )}
    </fieldset>
  );
});

export default OrderSourceTypeView;
